import { Section } from "@/ui";
import { Icon } from "@/ui";
import { useFlags } from "@/utils";

export const Dataroom = ({
    link,
    deactivate,
}: {
    link?: string;
    deactivate: boolean;
}) => {
    const flags = useFlags();
    const isDataroomEnabled = flags.enabled("enable-dataroom-link");

    if (!link || !isDataroomEnabled) return null;

    return (
        <Section className="py-10">
            <p className="subdued body-m mb-4">
                Want to learn more? Accept this deal in ICM to view the complete
                dataroom.
            </p>
            <p className="subdued body-m mb-4">
                Please ensure you have a signed MNDA with Hum Capital to
                activate the dataroom.
            </p>
            <button
                disabled={deactivate}
                onClick={() => window.open(link, "_blank")}
                className="lg flex items-center gap-2"
            >
                View Dataroom
                <Icon.ExternalLink className="size-8 fill-white" />
            </button>
        </Section>
    );
};
